import script from "./CouponList.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponList.vue?vue&type=script&setup=true&lang=js"

import "./CouponList.vue?vue&type=style&index=0&id=b2c9f808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2c9f808"]])

export default __exports__